// src/beta/components/PaginationTicks.tsx
interface Props {
  total: number;
  active: number;
}

/** Pagination ticks — sharp 1px lines along the bottom; active = 2px red. */
export function PaginationTicks({ total, active }: Props) {
  if (total <= 0) return null;

  return (
    <div
      role="tablist"
      style={{
        position: 'absolute',
        left: 0,
        right: 0,
        bottom: 'var(--vm-s-3)',
        display: 'flex',
        justifyContent: 'center',
        gap: 'var(--vm-s-1)',
        zIndex: 5,
      }}
    >
      {Array.from({ length: total }).map((_, i) => {
        const isActive = i === active;
        return (
          <span
            key={i}
            data-testid={`tick-${i}`}
            data-active={isActive ? 'true' : 'false'}
            style={{
              width: 32,
              height: isActive ? 2 : 1,
              background: isActive ? 'var(--vm-red)' : 'var(--vm-stone)',
              transition: 'height 200ms, background 200ms',
            }}
          />
        );
      })}
    </div>
  );
}
